import { Badge, BadgeProps, Text } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { PropsWithChildren } from 'react';

export default function InfoBadge({
  children,
  ...props
}: PropsWithChildren & BadgeProps) {
  const matches = useMediaQuery('(min-width: 1280px)');

  return (
    <Badge
      color='gray.2'
      px={matches ? 'md' : 'xs'}
      py={matches ? 'sm' : 'xs'}
      c='black'
      radius='md'
      {...props}
    >
      {children}
    </Badge>
  );
}
